import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService, UserNotification } from '@services/notifications.service';

/**
 * Campanita de Flows (ticket SUIT/CLM).
 *
 * Muestra lo que le concierne al usuario: requerimientos que le asignaron y alertas
 * de contrato suyas que ya vencieron. El feed lo deriva el backend de los registros
 * que ya existen, así que aquí no hay estado que mantener más allá de lo que se
 * pinta.
 *
 * No confundir con el interruptor de "notificaciones" del perfil, que decide si al
 * usuario le llegan correos. Comparten nombre y no tienen relación.
 */
@Component({
    selector: 'app-notification-bell',
    templateUrl: './notification-bell.component.html',
    styleUrls: ['./notification-bell.component.scss'],
    standalone: false
})
export class NotificationBellComponent implements OnInit {
  notifications: UserNotification[] = [];
  unreadCount = 0;
  loading = false;
  open = false;
  /** Se distingue "aún no cargó" de "cargó y no hay nada": el vacío solo se dice si de verdad no hay. */
  loaded = false;

  constructor(
    private notificationsService: NotificationsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Solo el contador al arrancar: la lista se pide al abrir, para no pagar el
    // feed completo en cada carga de página.
    this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    try {
      const data = await this.notificationsService.getUserNotifications();
      this.notifications = data.notifications;
      this.unreadCount = data.unreadCount;
      this.loaded = true;
    } catch {
      // Una campanita que rompe la navbar es peor que una campanita vacía.
      this.notifications = [];
      this.unreadCount = 0;
      this.loaded = true;
    } finally {
      this.loading = false;
    }
  }

  async toggle(): Promise<void> {
    this.open = !this.open;
    if (!this.open) return;

    await this.load();

    // Abrirla cuenta como verla: se apaga el contador al momento y se persiste la
    // marca. Si el POST falla, el contador vuelve en la próxima carga — mejor eso
    // que dejar el badge encendido sobre notificaciones que el usuario ya leyó.
    if (this.unreadCount > 0) {
      this.unreadCount = 0;
      try { await this.notificationsService.markNotificationsSeen(); } catch { /* reintenta solo */ }
    }
  }

  go(notification: UserNotification): void {
    this.open = false;
    this.router.navigateByUrl(notification.link);
  }

  iconFor(notification: UserNotification): string {
    return notification.kind === 'contract_alert' ? 'far fa-file-alt' : 'far fa-user-circle';
  }
}
